import React from 'react';
import styled from 'styled-components';

function facebook(f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function() {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
}

if (typeof window !== 'undefined')
    facebook(
        window,
        document,
        'script',
        'https://connect.facebook.net/en_US/fbevents.js'
    );

const pixels = [];

export const initializePixels = pixelIds => {
    pixelIds.forEach(id => {
        if (typeof window !== 'undefined') {
            window.fbq('init', id);
            if (pixels.indexOf(id) === -1) {
                pixels.push(id);
            }
        }
    });
};

export const trackContent = (
    type,
    widgetId,
    actionId,
    questionText,
    answerId,
    answerText
) => {
    const data = {
        content_type: type,
        content_ids: [widgetId, actionId, answerId],
        content_name: (questionText || '') + ' | ' + (answerText || '')
    };
    window.fbq('track', 'ViewContent', data);
};

export const trackWidgetVisible = (widgetId, articleUrl) => {
    const data = {
        content_ids: [widgetId, articleUrl]
    };
    window.fbq('track', 'PageView', data);
};

const Pixel = styled.img`
    height: 1px;
    width: 1px;
    display: none;
`;

const Container = styled.div``;

export const FacebookPixel = props => {
    return (
        <Container>
            {pixels.map(id => (
                <Pixel
                    key={id}
                    src={
                        'https://www.facebook.com/tr?id=' + id + '&ev=PageView&noscript=1'
                    }
                />
            ))}
        </Container>
    );
};



// WEBPACK FOOTER //
// ./src/utils/facebookPixel.js